import React from 'react';

const WhyRevolutionTravel = () => {
  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
            Why Choose Revolution Travel?
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-xl text-gray-500">
            Your trusted partner for extraordinary travel experiences
          </p>
        </div>

        <div className="mt-16">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="pt-6">
              <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                <div className="-mt-6">
                  <div className="inline-flex items-center justify-center p-3 bg-blue-500 rounded-md shadow-lg">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                    </svg>
                  </div>
                  <div className="mt-6 w-full h-48 bg-gray-200 rounded-lg overflow-hidden">
                    <img 
                      className="w-full h-full object-cover"
                      src="/VVHeadOffice.jpeg" 
                      alt="Number one agency"
                    />
                  </div>
                  <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">#1 Agency in Canada</h3>
                  <p className="mt-5 text-base text-gray-500">
                    Proudly recognized as Canada's #1 Virgin Voyages agent in 2023, setting the standard for excellence in cruise travel.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                <div className="-mt-6">
                  <div className="inline-flex items-center justify-center p-3 bg-blue-500 rounded-md shadow-lg">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div className="mt-6 w-full h-48 bg-gray-200 rounded-lg overflow-hidden">
                    <img 
                      className="w-full h-full object-cover"
                      src="/Top100_crop.jpeg" 
                      alt="Top 20 travel agent"
                    />
                  </div>
                  <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Top 20 Travel Agent</h3>
                  <p className="mt-5 text-base text-gray-500">
                    Honored as a Top 100 Agent with Virgin Voyages in North America for two consecutive years, earning a prestigious spot in the Top 20 in 2023. We bring unmatched expertise and personalized service to every booking.
                  </p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                <div className="-mt-6">
                  <div className="inline-flex items-center justify-center p-3 bg-blue-500 rounded-md shadow-lg">
                    <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" />
                    </svg>
                  </div>
                  <div className="mt-6 w-full h-48 bg-gray-200 rounded-lg overflow-hidden">
                    <img 
                      className="w-full h-full object-cover"
                      src="/VVAccess.jpeg" 
                      alt="Exclusive Access"
                    />
                  </div>
                  <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Exclusive Access</h3>
                  <p className="mt-5 text-base text-gray-500">
                    Access unique deals, exclusive fares, and special offers available through Revolution Travel, along with bonus loot on select voyages to ensure the best value for your journey.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyRevolutionTravel;
